import { store } from 'reduxActions';

// eslint-disable-next-line import/prefer-default-export
export function isUserReadOnly() {
  const { profile } = store.getState();
  if (profile.profile && profile.profile.myjobs_setting) {
    return profile.profile.myjobs_setting.read_only;
  }

  return true;
}
